<!--  -->
<template>
  <div class="pay">
    <div class="head">
      <span>
        当前搜索到
        <i style="color:#d32c3d">{{ num }}</i>条信息
      </span>
      <span class="icon llsj" @click="jumpBrowse">浏览数据</span>
      <span class="icon ffsx" @click="goback()">返回筛选</span>
    </div>
    <div class="content">
      <div class="box">
        <div style="margin-bottom:20px;">
          <el-divider direction="vertical" style="width:2px;"></el-divider>
          <span style="font-size:16px;vertical-align: middle;">数据规格</span>
        </div>
        <el-radio
          v-model="radio1"
          label="1"
          border
          v-for="item in priceList"
          :key="item.fieid"
          @change="count(item.fieid)"
        >
          {{ item.packetname
          }}
          <span style="color:#000;float:right;">
            <i
              style="text-decoration: line-through;color:#a0a0a0;margin-right:5px"
            >{{ item.packetprice }}元</i>
            <i style="line-through;color:#d32c3d;">{{ item.fieldPacketb }}元</i>/条
          </span>
        </el-radio>
        <!-- <el-radio v-model="radio1" label="2" border
          >高级字段包<span style="color:#000;float:right;"
            ><i
              style="text-decoration: line-through;color:#a0a0a0;margin-right:5px"
              >2元</i
            ><i style="line-through;color:#d32c3d;">1元</i>/条</span
          ></el-radio
        >-->
      </div>
      <div class="box">
        <div style="margin-bottom:20px;">
          <el-divider direction="vertical" style="width:2px;"></el-divider>
          <span style="font-size:16px;vertical-align: middle;">联系方式</span>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          @submit.native.prevent
        >
          <el-form-item label="手机:" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="box">
        <div style="margin-bottom:20px;">
          <el-divider direction="vertical" style="width:2px;"></el-divider>
          <span style="font-size:16px;vertical-align: middle;">应付总额</span>
        </div>
        <span style="margin-left:15px;">
          现价：
          <i
            style="color:#d32c3d;font-size:20px;margin-right:20px;"
          >￥{{ priceCount.fieldpacketb }}</i>
          <i style="text-decoration: line-through;color:#999">原价：{{ priceCount.packetprice }}</i>
        </span>
        <div style="margin-top:20px;margin-left:15px;">
          <el-checkbox v-model="checked"></el-checkbox>
          <span class="tk" @click="jump">我已阅读并同意《牵星出海产品与服务线上购买服务条款》</span>
          <div style="margin-top:30px">
            <el-button size="small" @click="jumpBrowse" class="bd">浏览数据</el-button>
            <el-button
              size="small"
              type="primary"
              @click="submitPay('ruleForm')"
              :disabled="disabled"
              class="paybtn"
            >确认支付</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
import tool from '../../tool/tool'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'pay',
  components: {},
  data() {
    //这里存放数据
    //这里存放数据
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[23456789]\d{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    }
    //邮箱验证
    var checkEmail = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (reg.test(value)) {
          this.disabled = false
          callback()
        } else {
          callback(new Error('邮箱格式不正确'))
        }
      }, 100)
    }
    return {
      radio1: '1',
      ruleForm: {
        phone: '',
        email: '',
      },
      rules: {
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: 'blur',
          },
        ],
        emailCode: [
          { required: true, message: '请输入验证码', trigger: 'change' },
        ],
      },
      checked: false, //协议勾选
      disabled: true, //支付按钮状态
      priceList: [],
      num: '', //总条数
      priceCount: {},
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    checked(val) {
      this.disabled = !this.checked
    },
  },
  //方法集合
  methods: {
    goData() {
      this.$router.push({
        path: '/mydata',
      })
    },
    jump() {
      const params = { numbercms: 102623 }
      let routeData = this.$router.resolve({
        name: 'publicPage',
        query: params,
      })
      window.open(routeData.href, '_blank')
    },
    submitPay(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.$qs.stringify({
            userid: tool.getCookie('user'),
            excelcode: this.$route.query.excelcode,
            recordsphone: this.ruleForm.phone,
          })
          this.axios
            .post(API_1 + Global.excel, params, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            })
            .then((res) => {
              if (res.data.status == 1) {
                this.$message({
                  message: '支付成功',
                  type: 'success',
                  offset: 100,
                  duration: 1000,
                  onClose: () => {
                    //此处写提示关闭后需要执行的函数
                    this.$router.push({
                      path: '/result',
                    })
                  },
                })
              } else if (res.data.status == 2) {
                this.$message({
                  message: '您的筛选结果已过期，请重新进行筛选。',
                  type: 'warning',
                  offset: 100,
                })
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 100,
                })
              }
            })
            .catch((res) => {
              this.$message({
                message: '网络连接失败，请刷新重试',
                type: 'error',
                offset: 100,
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    jumpBrowse() {
      let routeData = this.$router.resolve({
        path: '/browse',
        query: { excelcode: this.$route.query.excelcode },
      })
      window.open(routeData.href, '_blank')
    },
    count(type) {
      //行业
      let params = this.$qs.stringify({
        userid: tool.getCookie('user'),
        excelcode: this.$route.query.excelcode,
        fieid: type,
      })
      this.axios
        .post(API_1 + Global.count, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.priceCount = res.data.data
          } else if (res.data.status == 2) {
            this.$message({
              message: '您的筛选结果已过期，请重新进行筛选。',
              type: 'warning',
              offset: 100,
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 100,
            })
          }
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
    goback() {
      this.$router.push({
        path: 'payOption',
      })
    },
    getPrice() {
      //行业
      let params = {}
      this.axios
        .get(API_1 + Global.price, { params: params })
        .then((res) => {
          this.priceList = res.data.data
          let id = this.priceList[0].fieid
          this.count(id)
        })
        .catch((res) => {})
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPrice()
    this.num = this.$route.query.num
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {
    this.$emit('getStep', 2)
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.tk {
  cursor: pointer;
  margin-left: 10px;
  color: #999;
}
.el-divider {
  background: #87a6b8;
  width: 2px;
  margin-left: 0;
  height: 20px;
}
.el-radio {
  display: block;
  margin-left: 10px !important;
  width: 300px;
  margin-top: 10px;
}
.el-form {
  width: 300px;
  margin: 0 auto;
  .el-form-item {
    margin-bottom: 20px;
    width: 300px;
  }
  .el-input {
    width: 300px;
  }
}
.pay {
  width: 1200px;
  background: #fff;
  border-radius: 4px;
  margin: 20px auto;
  font-size: 14px;
  padding: 0 50px 30px;
  box-sizing: border-box;
  .head {
    text-align: left;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #eee;
    .llsj {
      background: url('../../assets/search.png') no-repeat center left;
      background-size: 16px 16px;
      padding-left: 20px;
      cursor: pointer;
      margin-left: 30px;
      color: #0f4d72;
    }
    .icon {
      background-size: 16px 16px;
      padding-left: 20px;
      cursor: pointer;
      margin-left: 30px;
      color: #0f4d72;
      &:hover {
        color: #178cd1;
      }
    }
    .llsj {
      background: url('../../assets/search.png') no-repeat center left;
    }
    .ffsx {
      background: url('../../assets/screen.png') no-repeat center left;
      float: right;
    }
  }
  .content {
    padding-top: 30px;
    .box {
      text-align: left;
      width: 330px;
      margin: 0 auto 40px;
      /deep/.bd {
        color: #666;
        border-color: #dcdcdc;
        &:hover {
          background: #0f4d72;
          color: #fff;
          border-color: #0f4d72;
        }
      }
      /deep/.paybtn {
        background: #0f4d72;
        color: #fff;
        border-color: #0f4d72;
        &:hover {
          background: #105e8c;
          border-color: #105e8c;
        }
      }
      /deep/.el-radio.is-bordered.is-checked {
        color: #0f4d72;
        border-color: #0f4d72;
      }
      /deep/ .el-input__inner:focus {
        border-color: #0f4d72;
      }
      /deep/.el-radio__input.is-checked .el-radio__inner {
        border-color: #0f4d72;
        background: #0f4d72;
      }
      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #0f4d72;
      }
      /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #0f4d72;
      }
      /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #0f4d72;
        background-color: #0f4d72;
        border-color: #0f4d72;
      }
      /deep/.el-checkbox__inner:hover {
        border-color: #0f4d72;
      }
      .el-button {
        width: 140px;
      }
    }
  }
}
</style>
